import { motion, useScroll, useTransform } from 'motion/react';
import { useRef } from 'react';

export function HeroSection() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"]
  });

  const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);
  const scale = useTransform(scrollYProgress, [0, 0.5], [1, 0.8]);
  const y = useTransform(scrollYProgress, [0, 0.5], [0, -100]);

  return (
    <section
      ref={ref}
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-20">
        <img
          src="/assets/imgs/case-studies/fitness_tracker_1.png"
          alt="Fresh vegetables"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0d0d0d] via-transparent to-[#0d0d0d]" />
      </div>

      <motion.div
        style={{ opacity, scale, y }}
        className="text-center px-6 z-10"
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h1 className="text-6xl md:text-8xl mb-6 tracking-tight">
            Fitness Tracker App
          </h1>
          <div className="h-1 w-24 bg-[#fd5b38] mx-auto mb-6" />
          <h2 className="text-2xl md:text-3xl text-gray-400">UX Case Study</h2>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="text-xl md:text-2xl mt-12 text-gray-300 max-w-3xl mx-auto"
        >
          Holistic fitness experience: workouts, meals & sleep tracking.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="text-lg md:text-xl mt-8 text-[#fd5b38] italic"
        >
          "Empowering healthier lifestyles—one step, meal, and workout at a
          time."
        </motion.p>
      </motion.div>

      <motion.div
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <div className="w-6 h-10 item-border-2 border-[#fd5b38] rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-[#fd5b38] rounded-full" />
        </div>
      </motion.div>
    </section>
  );
}
